export default __webpack_public_path__ + "static/media/business-problem4-en.6d7741c0.png";